import { ListItemIcon, styled, Typography, Box, Chip, IconButton } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) => {
    return prop !== 'disabled';
  },
})<{ disabled?: boolean }>(({ disabled }) => {
  return {
    marginBottom: '16px',
    pointerEvents: disabled ? 'none' : 'auto',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
  };
});

export const SelectedOptionsContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '4px',
  marginTop: '8px',
  cursor: 'default',
});

export const SelectedOption = styled(Chip)({
  cursor: 'default',
  width: 'max-content',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '4px',
  backgroundColor: palette.background.unknown,
  padding: '8px 16px',
  borderRadius: '32px',

  span: {
    fontSize: '12px',
    padding: '0',
    color: palette.text.header,
    fontWeight: 500,
    lineHeight: '16px',
  },

  button: {
    padding: '0',
    margin: '0 !important',
  },
});

export const DeleteIcon = styled(IconButton)(({ theme }) => {
  return {
    color: theme.palette.grey[600],
    transition: 'color 0.2s',
    padding: theme.spacing(0.5),

    '&:hover': {
      color: theme.palette.error.main,
    },
  };
});

export const SelectLabel = styled(Typography, {
  shouldForwardProp: (prop) => {
    return prop !== 'error';
  },
})<{ error?: string }>(({ error }) => {
  return {
    color: error ? palette.alerts.error : palette.text.header,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '128%',
    margin: '0 0 8px 0',
  };
});

export const ErrorMessage = styled(Typography)({
  color: palette.alerts.error,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  marginTop: '8px',
}) as typeof Typography;

export const AutocompleteOption = styled('li', {
  shouldForwardProp: (prop) => {
    return prop !== 'isSelected';
  },
})<{ isSelected?: boolean }>(({ isSelected }) => {
  return {
    color: palette.text.header,
    fontSize: '14px',
    fontWeight: isSelected ? 500 : 400,
    lineHeight: '136%',
    padding: '8px 12px !important',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: 'transparent !important',
    cursor: 'pointer',

    '&[aria-disabled="true"]': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },

    '&:hover, &.Mui-focused': {
      backgroundColor: '#F4E8FF !important',
    },
  };
});

export const Checkmark = styled(ListItemIcon)({
  minWidth: 'auto !important',
  color: '#3D1E66',

  '> svg': {
    width: '20px',
    height: '20px',
  },
});
